import { useApi2fetch } from 'containers/Api2/index.js';
import { upload } from './upload.js';

function useUpload() {
  const api2fetch = useApi2fetch();
  return (data, callback) => upload(data, api2fetch, callback);
}

export default useUpload;
